module.exports = __webpack_public_path__ + "img/teachers_bg.594355c2.png";